module.exports = __webpack_public_path__ + "img/logo-activity.6a99c9b4.png";